<mat-card class="mt-3">
    <mat-card-content>

        <div class="row no-gutters">
            <div class="col-sm-12">
                <mat-form-field class="full-width">
                    <mat-label>{{ department.trans.companyname | translate }}</mat-label>
                    <input id="{{idPrefix}}{{department.trans.companyname}}"
                           type="text" matInput
                           [formControl]="company_name"
                           required>
                    <mat-error *ngIf="company_name.invalid">{{ getCompanyNameError() | translate }}</mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-sm-6">
                <a id="{{idPrefix}}btn.cancel"
                   mat-stroked-button
                   color="primary"
                   class="w-100"
                   (click)="cancel()">
                    {{ 'common.btn.cancel' | translate }}
                </a>
            </div>
            <div class="col-sm-6">
                <button id="{{idPrefix}}btn.save"
                        mat-flat-button color="accent" class="w-100"
                        (click)="submit()"
                        [disabled]="disabled || !hasChanges">{{ 'common.btn.save' | translate }}
                </button>
            </div>
        </div>

    </mat-card-content>
</mat-card>
